import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect, ConnectedProps } from 'react-redux';
import { updateDates, search } from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';
import { getSelectedDateSelectorFromState } from './getSelectedDateSelectorFromState';

const mapState = ({ queryParams }: StateType) => {
  const { dates } = queryParams;

  return {
    defaultDateSelectorSelected: getSelectedDateSelectorFromState(
      dates.from,
      dates.to,
    ),
    selectedValue: dates,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onDatesUpdate(dates: { from?: string; to?: string }) {
    dispatch(updateDates(dates));
    dispatch(search({ reason: 'faceted' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
